module.exports = __webpack_public_path__ + "img/search.23fe7c7d.svg";